import { useEffect } from "react";
import { RouterProvider } from "react-router-dom";
import { QueryClientProvider } from "@tanstack/react-query";
import { Toaster } from "sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { ThemeProvider } from "@/components/theme/theme-provider";
import { queryClient } from "@/lib/query-client";
import { router } from "@/router";
import { subscribeToQueryCacheClear } from "@/lib/demo-mode";

function QueryCacheClearSubscriber() {
  useEffect(() => {
    return subscribeToQueryCacheClear(() => queryClient.clear());
  }, []);
  return null;
}

export default function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <QueryCacheClearSubscriber />
      <ThemeProvider>
        <TooltipProvider delayDuration={200}>
          <RouterProvider router={router} />
          <Toaster position="top-center" richColors closeButton />
        </TooltipProvider>
      </ThemeProvider>
    </QueryClientProvider>
  );
}
